import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import LetPassAccountContMain from "presentation/view/container/LetPassAccount/LetPassAccountContMain";

CommonEntrypoint(<LetPassAccountContMain />)